// extracted by mini-css-extract-plugin
export var action = "video-module--action--0dd3c";
export var active = "video-module--active--567f1";
export var caption = "video-module--caption--a963f";
export var cover = "video-module--cover--e0516";
export var player = "video-module--player--dedd0";
export var root = "video-module--root--aec13";
export var videoWrap = "video-module--videoWrap--5bbf1";